import {
  buildAutoRenewalBody,
  buildExpiringMembershipBody,
  DONOR_DASHBOARD_URL_PLACEHOLDER,
  FORM_URL_PLACEHOLDER,
  Locales,
  MembershipRenewalBodyParts,
} from "@simplyk/common";

import { Translate } from "@/common/hooks/useTranslate";

const chip = (variable: string, label: string) =>
  `<span data-custom-variable="{{${variable}}}" class="fr-deletable styled-tag-chip" contenteditable="false">${label}</span>`;

const buildEditorParts = (
  orgName: string,
  userName: string,
  t: Translate
): Omit<MembershipRenewalBodyParts, "url"> => ({
  firstName: chip("firstname", t("dashboard", "membership.renewalEmail.variable.buyerFirstName")),
  membershipType: chip("Membership type", t("dashboard", "membership.renewalEmail.variable.membershipType")),
  expiryDate: chip("Expiry date", t("dashboard", "membership.renewalEmail.variable.expiryDate")),
  memberSuffix: ` (${chip("Member first name", t("dashboard", "membership.renewalEmail.variable.memberFirstName"))} ${chip("Member last name", t("dashboard", "membership.renewalEmail.variable.memberLastName"))})`,
  renewalAmount: chip("Renewal amount", t("dashboard", "membership.renewalEmail.variable.renewalAmount")),
  paymentMethod: chip("Payment method", t("dashboard", "membership.renewalEmail.variable.paymentMethod")),
  orgName,
  signature: userName ? `<p>${userName}<br/>${orgName}</p>` : `<p>${orgName}</p>`,
});

export const getDefaultExpiringBody = (orgName: string, userName: string, locale: Locales, t: Translate): string =>
  buildExpiringMembershipBody({ ...buildEditorParts(orgName, userName, t), url: FORM_URL_PLACEHOLDER }, locale);

export const getDefaultAutoRenewalBody = (orgName: string, userName: string, locale: Locales, t: Translate): string =>
  buildAutoRenewalBody({ ...buildEditorParts(orgName, userName, t), url: DONOR_DASHBOARD_URL_PLACEHOLDER }, locale);
